import React from 'react';

import * as yup from 'yup';
import styled from '@emotion/styled';
import { useFormik } from 'formik';
import { CustomerJourneyStep, useCustomerJourneyStep } from 'core';
import { FormFooter } from 'components';
import { selectSelectedCountryId } from 'store/country/countrySlice';
import { useAppSelector } from 'store';
import { useGetGlobalTncQuery, useGetLocalTncQuery } from 'store/terms-and-conditions/termsAPI';
import DOMPurify from 'dompurify';

import { Button } from '@britishcouncil/react-solas';
import { useFormFields } from '@britishcouncil/react-forms';
import { MainContainer, PageContainer, PageLoader, TnCCheckbox } from '@britishcouncil/react-solas-ors3';

import { useCreateRegistrationSubmit } from './useCreateRegistrationSubmit';

export const TermsAndConditions = () => {
  useCustomerJourneyStep(CustomerJourneyStep.TermsAndConditions);
  const countryId = useAppSelector(selectSelectedCountryId);

  const { data: globalTnC, isFetching: globalTnCLoading } = useGetGlobalTncQuery(countryId);
  const { data: localTnC, isFetching: localTnCLoading } = useGetLocalTncQuery(countryId);
  const { submit, serverErrors, isSubmitting } = useCreateRegistrationSubmit();

  const formik = useFormik({
    initialValues: {
      tncAccepted: false,
    },
    validationSchema: yup.object().shape({
      tncAccepted: yup.boolean().isTrue('Please accept terms and conditions.'),
    }),
    onSubmit: submit,
  });
  const fields = useFormFields(formik);

  return (
    <>
      <MainContainer>
        <h1>Summary terms and conditions</h1>
      </MainContainer>
      <PageContainer>
        {globalTnCLoading || localTnCLoading ? (
          <PageLoader />
        ) : (
          <StyledTCContainer>
            <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(globalTnC?.text || '') }} />
            <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(localTnC?.text || '') }} />
          </StyledTCContainer>
        )}
        <p>
          By clicking <strong>“Accept”</strong> you confirm that you have <strong>read</strong> and{' '}
          <strong>agree</strong> to the terms and conditions
        </p>
        <TnCCheckbox {...fields.tncAccepted}>I have read the terms and conditions</TnCCheckbox>
        <FormFooter mainErrors={!isSubmitting ? serverErrors : undefined}>
          <Button
            intent="success"
            onClick={formik.submitForm}
            disabled={isSubmitting || !formik.values.tncAccepted}
            loading={isSubmitting}
          >
            Complete registration
          </Button>
        </FormFooter>
      </PageContainer>
    </>
  );
};

const StyledTCContainer = styled.div`
  background-color: #fff;
  padding: 20px;
  margin-bottom: 20px;
  word-break: break-word;
`;
